import React, { useState } from 'react';
import { translate } from 'react-i18next';
import { object, func, shape, array, number } from 'prop-types';
import qs from 'query-string';

import ContractPeriodSelector from './components/ContractPeriodSelector';
import Subscription from '../Subscription';

import { NO_CONTRACT, YEARLY } from '@dragonfruit/constants/contractPeriods';
import styles from './SubscriptionSection.scss';

function SubscriptionSection({
  defaultSubscriptionGroupKey,
  webSubscriptionGroupMapping: { planGroups, planGroupKeys },
  location,
  t,
}) {
  /**
   * If query string's `annualPlan = true` and planGroupKeys contains 12, use it.
   * or if planGroupKeys contains the defaultSubscriptionGroupKey, use it.
   * Otherwise, take the first one in the planGroupKeys as default.
   */
  const { annualPlan } = qs.parse(location.search);

  const checkHasContractPeriod = contractPeriod =>
    planGroupKeys.includes(contractPeriod);

  const getInitialContractPeriod = () => {
    if (annualPlan === 'true' && checkHasContractPeriod(YEARLY)) return YEARLY;
    if (checkHasContractPeriod(defaultSubscriptionGroupKey))
      return defaultSubscriptionGroupKey;
    return planGroupKeys[0];
  };

  const [activeContractPeriod, setActiveContractPeriod] = useState(
    getInitialContractPeriod()
  );

  const showContractPeriodSelector = planGroupKeys.length > 1;
  const plans = planGroups[activeContractPeriod];

  const contractPeriodLabelMapping = {
    [NO_CONTRACT]: t('premium.subscriptions.planNameMonthly'),
    [YEARLY]: t('premium.subscriptions.planNameAnnual'),
  };

  const contractPeriodList = planGroupKeys.map(contractPeriod => ({
    value: contractPeriod,
    label:
      contractPeriodLabelMapping[contractPeriod] ||
      t('premium.subscriptions.planNameMonthlyPlural', {
        count: contractPeriod,
      }),
  }));

  const renderSubscriptionList = (subscriptionPlan, subscriptionPlanIdx) => (
    <Subscription {...subscriptionPlan} key={subscriptionPlanIdx} />
  );

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        {showContractPeriodSelector && (
          <ContractPeriodSelector
            options={contractPeriodList}
            value={activeContractPeriod}
            onChange={targetValue => setActiveContractPeriod(targetValue)}
          />
        )}
      </div>
      <div className={styles.plans}>{plans.map(renderSubscriptionList)}</div>
    </div>
  );
}

SubscriptionSection.propTypes = {
  location: object.isRequired,
  t: func.isRequired,
  defaultSubscriptionGroupKey: number,
  webSubscriptionGroupMapping: shape({
    planGroups: object.isRequired,
    planGroupKeys: array.isRequired,
  }),
};

export default translate(['premium'])(SubscriptionSection);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SubscriptionSection/SubscriptionSection.jsx